// lib/invoiceTotals.ts
import type { CreditGrantDTO } from '#types/types';

/** Amounts are comparable only within a currency; no exchange rate is implied. */
export function invoiceTotals(invoices: CreditGrantDTO['invoices']): Array<[string, number]> {
  const totals = new Map<string, number>();
  for (const invoice of invoices) {
    const currency = invoice.currency.toUpperCase();
    totals.set(currency, (totals.get(currency) ?? 0) + invoice.totalAmount);
  }
  return [...totals].sort(([a], [b]) => a.localeCompare(b));
}
